import { useContext } from 'react'

import { useQuery } from '@tanstack/react-query'

import { fetchSalesforceByAccount, fetchSalesforceByDomain } from 'api/ConversationAPI'
import { EnabledIntegrationsContext } from 'context/enabledIntegrations'
import { ActivityGroupByEndUser, CompanyData } from 'modules/accountActivity/domain'
import { SalesforceAPIData } from 'typings/salesforce'

const useSalesforceData = (
  input: ActivityGroupByEndUser | CompanyData
): SalesforceAPIData | undefined => {
  const { salesforce } = useContext(EnabledIntegrationsContext)
  const fetcherKey =
    input &&
    `${('endUserData' in input && input.endUserData.email) || ('domain' in input && input.domain)}`

  const { data: salesforceData } = useQuery({
    queryKey: ['fetchSalesforce', salesforce && fetcherKey ? fetcherKey : null],
    enabled: salesforce,
    queryFn: () => {
      if ('endUserData' in input && input.endUserData.email) {
        return fetchSalesforceByAccount(input.endUserData.email)
      }
      if ('domain' in input && input.domain) {
        return fetchSalesforceByDomain(input.domain)
      }
    }
  })

  return salesforceData?.data
}

export default useSalesforceData
